import { render, staticRenderFns } from "./CreateInvoice.vue?vue&type=template&id=35100a5c&"
import script from "./CreateInvoice.vue?vue&type=script&lang=js&"
export * from "./CreateInvoice.vue?vue&type=script&lang=js&"
import style0 from "src/components/Invoices/Create/create-invoice.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateInvoice.vue"
export default component.exports